export const FIELD_WIDTH = 420;
export const FIELD_HEIGHT = FIELD_WIDTH;
// Fixed scale: tall stacks are followed by vertical camera scrolling.
export const VIEW_WIDTH = FIELD_WIDTH / 0.86;
export const VIEW_SIDE = (VIEW_WIDTH - FIELD_WIDTH) / 2;
// Initial viewport and default spawn height; only a nearby stack raises the spawn.
export const VIEW_TOP = -80;
export const DROP_SPAWN_Y = -30;
export const DROP_CLEARANCE = 24;
export const VIEW_HEIGHT = FIELD_HEIGHT + VIEW_SIDE - VIEW_TOP;
// The physical world stays in 420-unit coordinates. The renderer uses twice
// as many pixels so the CSS-sized desktop board does not magnify a low-res
// canvas.
export const RENDER_RESOLUTION_SCALE = 2;
export const DANGER_LINE_Y = 112;
export const DANGER_DURATION_MS = 2_000;
export const MERGE_DANGER_GRACE_MS = 600;
export const FIXED_STEP_HZ = 120;
export const FIXED_STEP_MS = 1_000 / FIXED_STEP_HZ;
export const MAX_FRAME_DELTA_MS = 100;
export const MAX_SUBSTEPS = 12;
export const COMMON_DENSITY = 0.0018;
export const RESTITUTION = 0.08;
export const FRICTION = 0.35;
export const FRICTION_STATIC = 0.55;
export const FRICTION_AIR = 0.012;
export const WORLD_GRAVITY = 1.45;
export const AUTO_FALL_SPEED = 0.225;
export const DROP_INITIAL_SPEED = 12;
// Minimum interval after confirming a drop; landing does not block the next piece.
export const DROP_INTERVAL_MS = 300;
export const DROP_SETTLE_MS = 240;
export const MAX_STEP_DISPLACEMENT_RATIO = 0.5;
export const COLLISION_CORE_THICKNESS_RATIO = 0.42;
export const DROP_BAG_COUNTS = [7, 5, 4, 3, 1] as const;
export const PHASE_TRIGGER_STAGES = [10, 15, 20, 25] as const;
// Linear size relative to the calibrated growth curve, including phase 1.
// Start with meaningful board pressure; later resonances add 11–14% area each.
export const PHASE_SIZE_MULTIPLIERS = [1.5, 1.6, 1.7, 1.8, 1.9] as const;
// Ease into growth, then increase each merge's area ratio near resonance.
// 1 is constant geometric growth; 1.35 keeps at least 17% merge area relief.
export const EVOLUTION_GROWTH_EXPONENT = 1.35;

export const PRESENTATION_DURATION_MS = {
  phase: 1_050,
  shinra: 1_450,
  // Delay from the observer reveal to its movie.
  observer: 600,
  gameOverSlowMotion: 650,
} as const;
